import { HiCheckCircle } from 'react-icons/hi2'

export function SuccessFeedback({ close, createNew }) {
	return (
		<div className='tw-bg-white tw-flex tw-justify-center tw-items-center tw-w-[474px] tw-rounded-md tw-flex-col tw-gap-2 tw-px-5 tw-py-3'>
			<HiCheckCircle className='tw-text-purple tw-my-3' size={68} />
			<h3 className='tw-m-0 tw-p-0 tw-my-3'>Feedback enviado con éxito.</h3>
			<button onClick={createNew} className='border tw-py-2 tw-rounded-full tw-w-full tw-bg-white'>
				Enviar un nuevo feedback
			</button>
			<button onClick={close} className='border tw-py-2 tw-rounded-full tw-w-full tw-bg-purple tw-text-white'>
				Ver la lista de feedbacks
			</button>
		</div>
	)
}
